import styled from "styled-components";

import InputLabel from "../../../styles/input/InputLabel.styled";
import FlagContainer from "./FlagContainer.styled";

interface SelectContainerProps {
  direction: "ltr" | "rtl";
}

const SelectContainer = styled.div<SelectContainerProps>`
  position: relative;
  height: 52px;

  .separator {
    display: none;
  }

  ${InputLabel} {
    position: ${({ theme }) =>
      theme.pickerLabelAbsolutePosition ? "absolute" : "initial"};
    left: ${({ theme, direction }) =>
      direction === "ltr" ? theme.pickerLabelLeft : "initial"};
    right: ${({ theme, direction }) =>
      direction === "rtl" ? theme.pickerLabelLeft : "initial"};
    top: ${({ theme }) => theme.pickerLabelTop};
  }

  ${FlagContainer} {
    width: 29px;
    height: 19px;
    position: absolute;

    transform: translate(0, 9px);
  }

  .select-chevron {
    display: none;
  }
`;

export default SelectContainer;
